import packageJson from '../package.json';

export const VERSION: string = packageJson.version;
